/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment, useEffect, useState } from 'react'
import { array, object, string, func } from 'prop-types'
import styled from 'styled-components'
import TabList from '@taglivros/oef_componentes/build/components/tabList'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import CardPlano from './CardPlano'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { METODO_PAGAMENTO_CARTAO, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, PLANO_ANUAL } from '../../../constants'
import { TITULO_TELA_PLANO } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'

const WrapperEscolhaPlano = styled.section`
  color: ${StyleGuide.cores.cinza500};
  margin-bottom: 20px;
  width: 100%;

  @media (min-width: ${StyleGuide.mediaQuery.tablet}) {
    display: inline-flex;
  }
`

const ContentCardEscolhaPlano = styled.div`
  margin-top: 20px;
`

const ContentEscolhaPlano = styled.div`
  max-width: 430px;
  width: 100%;

  h3 {
    margin-bottom: 10px;
  }
`

const DescricaoEscolhaPlano = styled.div`
  margin-right: 90px;
  width: 100%;

  p {
    margin: 10px 0;
  }

  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 200px;
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin-bottom: 25px;
  }
`

const EscolhaPlano = ( { descricao, etapaAtual, listaPlanos, modalidade, setIdPlano } ) => {
  const { setarDadosEtapas, temaFluxo } = useFluxosPagamento()
  const [ planoSelecionado, setPlanoSelecionado ] = useState( 0 )
  const [ visualizacaoPlanos, setVisualizacaoPlanos ] = useState( {} )
  const isIneditos = modalidade === MODALIDADE_INEDITOS.slug

  useEffect( () => {
    const anual = document.querySelectorAll( '.tab-list-reativacao li:nth-child(1)' )
    const mensal = document.querySelectorAll( '.tab-list-reativacao li:nth-child(2)' )
    const trimestral = document.querySelectorAll( '.tab-list-reativacao li:nth-child(3)' )
    if ( anual.length && mensal.length ) {
      anual[ 0 ].setAttribute( 'data-testid', 'anual' )
      mensal[ 0 ].setAttribute( 'data-testid', 'mensal' )
      trimestral[ 0 ].setAttribute( 'data-testid', 'trimestral' )
    }
  }, [ listaPlanos ] )

  useEffect( () => {
    if ( listaPlanos && listaPlanos.length ) {
      const filtrarPlanosCartao = listaPlanos
        .filter( plano => plano.metodosPagamento.includes( METODO_PAGAMENTO_CARTAO.visualizacao ) )
        .sort( ( planA, planB ) => planA.tipo < planB.tipo ? -1 : 1 )
      const tabs = filtrarPlanosCartao.map( plano => ( { 'codigo': plano.id, 'visualizacao': plano.tipo } ) )

      tabs.forEach( menu => {
        if ( menu.visualizacao === PLANO_ANUAL.visualizacao ) {
          setIdPlano( menu.codigo )
          setPlanoSelecionado( menu.codigo )
        }
      } )

      setVisualizacaoPlanos( {
        'card': filtrarPlanosCartao,
        'tab': tabs
      } )
    }
  }, [ listaPlanos ] )

  useEffect( () => {
    if ( planoSelecionado ) {
      setIdPlano( planoSelecionado )
      const valorPlanoSelecionado = listaPlanos.find( plano => plano.id === planoSelecionado ).valorTotal
      const tipoPlanoSelecionado = listaPlanos.find( plano => plano.id === planoSelecionado ).tipo
      setarDadosEtapas(
        {
          'id': planoSelecionado,
          'tipo': tipoPlanoSelecionado,
          'valor': valorPlanoSelecionado
        },
        etapaAtual.identificador
      )
    }
  }, [ planoSelecionado ] )

  return (
    <Fragment>
      { !isEmptyObject( visualizacaoPlanos ) && visualizacaoPlanos.tab.length ?
        <WrapperEscolhaPlano>
          <DescricaoEscolhaPlano>
            <h3>{ isIneditos ? MODALIDADE_INEDITOS.titulo : MODALIDADE_CURADORIA.titulo }</h3>

            <p>{ descricao }</p>
          </DescricaoEscolhaPlano>

          <ContentEscolhaPlano>
            <h3>{ TITULO_TELA_PLANO }</h3>

            <div className="tab-list-reativacao">
              <TabList
                ativo={ planoSelecionado }
                itens={ visualizacaoPlanos.tab }
                onClick={ codigo => setPlanoSelecionado( codigo ) }
                optionalColor={ temaFluxo }
              />
            </div>

            <ContentCardEscolhaPlano>
              { visualizacaoPlanos.card.map( plano => (
                <Fragment key={ plano.id }>
                  { planoSelecionado === plano.id &&
                    <CardPlano
                      modalidade={ modalidade }
                      plano={ plano }
                      selecionarPlano={ () => setPlanoSelecionado( plano.id ) }
                    />}
                </Fragment>
              ) ) }
            </ContentCardEscolhaPlano>
          </ContentEscolhaPlano>
        </WrapperEscolhaPlano> :
        <InlineLoader
          cor={ temaFluxo }
          isCenter
        />}
    </Fragment>
  )
}

EscolhaPlano.defaultProps = {
  'setIdPlano': () => {}
}

EscolhaPlano.propTypes = {
  'descricao': string.isRequired,
  'etapaAtual': object.isRequired,
  'listaPlanos': array.isRequired,
  'modalidade': string.isRequired,
  'setIdPlano': func
}

export default EscolhaPlano
